// JavaScript code for acf_blocks/visit-cards component
(($) => {
  "use strict";
  console.log("acf_blocks/visit-cards scripts loaded…");

  const cards = document.querySelectorAll(".eat-shop-play-block .col-md-4");

  cards.forEach((card) => {
    const img = card.querySelector(".esp-zoom-img");
    if (!img) return;

    // zoom-in timeline
    const tl = gsap
      .timeline({ paused: true })
      .to(img, { scale: 1.05, duration: 0.4, ease: "power2.out" });

    /* ───────── DESKTOP (hover) ───────── */
    card.addEventListener("mouseenter", () => tl.play());
    card.addEventListener("mouseleave", () => tl.reverse());

    /* ───────── MOBILE (tap toggle) ───── */
    card.addEventListener(
      "touchstart",
      (e) => {
        // If the user tapped directly on a link, let it fire.
        if (e.target.closest("a")) return;

        // Toggle zoom only; no preventDefault → links keep working
        tl.reversed() ? tl.play() : tl.reverse();
      },
      { passive: true }
    );
  });

  /* ---------- GSAP scroll animation (unchanged) ---------- */
  $(document).ready(() => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined")
      return;

    gsap.registerPlugin(ScrollTrigger);
    gsap.set(".animation-top-featured", { y: 40, autoAlpha: 0 });

    gsap
      .timeline({
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: ".animation-top-featured",
          start: "top 75%",
          toggleActions: "play none none none",
        },
      })
      .to(".animation-top-featured", {
        duration: 1,
        y: 0,
        autoAlpha: 1,
        stagger: 0.25,
      });
  });

  /* ---------- Slick slider init (unchanged) -------------- */
  const $slider = $(".eat-shop-play-block .multiple-items");

  // Ajuste na função: tira o guard que dependia de SLICK_CONFIG
  function handleSlick() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      if (!$slider.hasClass("slick-initialized")) {
        $slider.slick({
          dots: true,
          arrows: false,
          infinite: false, // manaintain the firs slide at right
          speed: 300,
          slidesToShow: 1, 
          slidesToScroll: 1,
          variableWidth: true, // 💡 let the css dictate the size
          initialSlide: 0,
        });
      }
    } else if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick"); 
    }
  }

  $(document).ready(() => {
    if (typeof SLICK_CONFIG === "undefined") {
      console.error("SLICK_CONFIG is undefined — arrow SVG paths not passed.");
      return;
    }
    handleSlick();
    $(window).on("resize", handleSlick);
  });
})(jQuery);
